import axios from "axios";
import { RootState, store } from "./store";
import { messageActions } from "./store/reducers/messages";
import { authActions } from "./store/reducers/auth";
import { msalInstance } from ".";
import { loginRequest } from "./config/auth";

const apiService = axios.create({
    baseURL: process.env.REACT_APP_API_URL
});

apiService.interceptors.request.use(
    (config) => {
        const state: RootState = store.getState();
        if (state.auth.authenticated) {
            config.headers.Authorization = `Token ${state.auth.token}`;
        }

        refreshAzureToken();
        
        return config;
    }, (e) => {
        // Request error
        store.dispatch(messageActions.add({title: "Serverfout", body: "Er is iets fout gegaan bij het verwerken van het verzoek.", duration: 0}))
    }
)

apiService.interceptors.response.use(
    (response) => {
        return Promise.resolve(response);
    }, (e) => {
        store.dispatch(messageActions.add({title: "Serverfout", body: "Er is iets fout gegaan bij het verwerken van het verzoek.", duration: 0}));

        if (e.status === 401) {
            store.dispatch(authActions.signout());
        }

        return Promise.reject(e);
    }
)

const refreshAzureToken = async () => {
    const account = msalInstance.getActiveAccount();
    if (account) {
        msalInstance.acquireTokenSilent({ scopes: loginRequest.scopes, account: account });
    }
}

export default apiService;